import { SectionVM, CertificatoSanitario } from 'civil-status/view-models/step-form';

export const transformerCertificatoSanitario = (
  dataSection?: SectionVM
): CertificatoSanitario | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: dataSection.idCertSanitario
      ? {
          idCertSanitario: dataSection.idCertSanitario,
        }
      : undefined,
    autorita: dataSection.certificateReleaseFrom || undefined,
    dataRilascio: dataSection.certificateDate
      ? dataSection.certificateDate?.toFormat('yyyy-MM-dd')
      : undefined,
  };
};
